module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-summary"
  }, [_c('div', {
    staticClass: "blackBG-words"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [(!_vm.results) ? _c('div', [(_vm.text) ? _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.text == "win" ?
    _vm.$t("engGame.eng-summery.welldone") :
    _vm.$t("engGame.eng-summery.improve")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.text == 'lose') ? _c('div', [_c('div', {
    staticClass: "engSen"
  }, [_vm._v(_vm._s(_vm.wengSen))]), _vm._v(" "), _c('div', {
    staticClass: "hebSen"
  }, [_vm._v(_vm._s(_vm.whebSen))])]) : _vm._e(), _vm._v(" "), (_vm.text == 'win') ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.outText))]) : _vm._e(), _vm._v(" "), (_vm.audioSrc && _vm.text == 'win') ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audioSrc && _vm.text == 'win') ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc && _vm.text == 'win') ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc && _vm.text == 'win') ? _c('VideoPlayer1', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc && _vm.text == 'win') ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.imgSrc && _vm.text == 'win'
    }
  }) : _vm._e(), _vm._v(" "), _c('Spacer', {
    attrs: {
      "height": "12"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex btnsDiv"
  }, [_c('button', {
    staticClass: "btnSummry btnRestart",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("engGame.eng-summery.again")) + "\n      ")])]), _vm._v(" "), (_vm.text == 'win') ? _c('button', {
    staticClass: "btnSummry btnGo",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("engGame.eng-summery.continue")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cde1b4e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EngGame/eng-summery.vue
// module id = 456
// module chunks = 1 4